import React from "react";
import { formatDateTime, getLevelBadgeClass, getOutcomeBadgeClass } from "./utils";

const RedisLogTable = ({filteredLogs,loading,actionLoading,searchText,onSearchTextChange,
  onRefresh,onStart,onStop,onStreamToggle,isStreaming,monitorStatus,error,onDeleteLog,deletingLogId,}) => {
  return (
    <>
      <div className="row g-2 align-items-end mb-3">
        <div className="col-lg-4 col-md-6">
          <label className="form-label" htmlFor="redis-log-search">
            Search loaded rows
          </label>
          <div className="input-group">
            <span className="input-group-text">
              <i className="bi bi-search" aria-hidden="true"></i>
            </span>
            <input
              id="redis-log-search"
              type="search"
              className="form-control"
              value={searchText}
              onChange={onSearchTextChange}
              placeholder="Booking ref, event, status, summary"
            />
          </div>
        </div>

        <div className="col-lg-8 col-md-6">
          <div className="d-flex justify-content-lg-end gap-2 flex-wrap">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onRefresh}
              disabled={loading || actionLoading}
            >
              <i className="bi bi-arrow-clockwise me-1" aria-hidden="true"></i>
              Refresh
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={onStart}
              disabled={loading || actionLoading || monitorStatus.running}
            >
              <i className="bi bi-play-fill me-1" aria-hidden="true"></i>
              Start
            </button>
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={onStop}
              disabled={loading || actionLoading || !monitorStatus.running}
            >
              <i className="bi bi-stop-fill me-1" aria-hidden="true"></i>
              Stop
            </button>
          </div>
        </div>
      </div>

      {error && <div className="alert alert-danger py-2">{error}</div>}

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col" className="text-nowrap">
                Time
              </th>
              <th scope="col">Event</th>
              <th scope="col">Booking</th>
              <th scope="col">Result</th>
              <th scope="col">Lock</th>
              <th scope="col">Service</th>
              <th scope="col">Summary</th>
              <th scope="col" className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  Loading Redis logs...
                </td>
              </tr>
            ) : filteredLogs.length > 0 ? (
              filteredLogs.map((log, index) => (
                <tr key={`${log.id}-${index}`}>
                  <td className="text-muted">{index + 1}</td>
                  <td className="text-nowrap">{formatDateTime(log.timestamp)}</td>
                  <td style={{ minWidth: "190px" }}>
                    <div className="fw-semibold">{log.event || "-"}</div>
                    <div className="d-flex gap-1 flex-wrap mt-1">
                      {log.kind && (
                        <span className="badge bg-light text-dark border">{log.kind}</span>
                      )}
                      {log.level && log.level !== "LOG" && (
                        <span className={`badge ${getLevelBadgeClass(log.level)}`}>
                          {log.level}
                        </span>
                      )}
                    </div>
                  </td>
                  <td style={{ minWidth: "170px" }}>
                    <div className="fw-semibold">{log.bookingRef || "-"}</div>
                    {log.orderId && <div className="small">Order: {log.orderId}</div>}
                    {log.paymentId && (
                      <div className="small">Payment: {log.paymentId}</div>
                    )}
                  </td>
                  <td style={{ minWidth: "130px" }}>
                    {log.bookingStatus && (
                      <div>
                        <span className="badge bg-info text-dark">
                          {log.bookingStatus}
                        </span>
                      </div>
                    )}
                    {log.outcome && (
                      <div className="mt-1">
                        <span className={`badge ${getOutcomeBadgeClass(log.outcome)}`}>
                          {log.outcome}
                        </span>
                      </div>
                    )}
                    {!log.bookingStatus && !log.outcome && "-"}
                  </td>
                  <td style={{ minWidth: "170px" }}>
                    <div>{log.lockType || "-"}</div>
                    {log.lockStatus && (
                      <div className="small">Status: {log.lockStatus}</div>
                    )}
                    {log.deletedKeys !== "" && log.deletedKeys !== undefined && (
                      <div className="small">Deleted keys: {log.deletedKeys}</div>
                    )}
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    <div>{log.service || "Redis"}</div>
                    {log.traceId && <div className="small text-break">Trace: {log.traceId}</div>}
                  </td>
                  <td style={{ minWidth: "360px", whiteSpace: "pre-wrap" }}>
                    {log.summary || "-"}
                  </td>
                  <td className="text-center">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      title="Delete this log entry"
                      disabled={deletingLogId === log.id}
                      onClick={() => onDeleteLog(log.id)}
                    >
                      {deletingLogId === log.id ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        <i className="bi bi-trash" aria-hidden="true"></i>
                      )}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No Redis logs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RedisLogTable;
